"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AutoGrowTextInput_1 = __importDefault(require("AutoGrowTextInput/AutoGrowTextInput"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var NumberInput = (function (_super) {
    __extends(NumberInput, _super);
    function NumberInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowingBoundaryError = false;
        _this.isWithinBoundaries = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            if (!(0, lodash_1.isUndefined)(min) && value < min) {
                return false;
            }
            if (!(0, lodash_1.isUndefined)(max) && value > max) {
                return false;
            }
            return true;
        };
        _this.updateValue = function (value) {
            var onChange = _this.props.onChange;
            var valueAsNumber = Number(value);
            if (isNaN(valueAsNumber)) {
                _this.internalValue = value;
                return;
            }
            if (!_this.isWithinBoundaries(valueAsNumber)) {
                _this.internalValue = value;
                return;
            }
            if (valueAsNumber.toString() !== value) {
                _this.internalValue = value;
            }
            else {
                _this.internalValue = undefined;
            }
            onChange(valueAsNumber);
        };
        _this.validateAndClearInternalValue = function () {
            var internalValueAsNumber = Number(_this.internalValue);
            if (!isNaN(internalValueAsNumber) && !_this.isWithinBoundaries(internalValueAsNumber)) {
                _this.showBoundaryError();
            }
            _this.internalValue = undefined;
        };
        _this.showBoundaryError = function () {
            if (!(0, lodash_1.isNil)(_this.boundaryErrorTimeout)) {
                clearTimeout(_this.boundaryErrorTimeout);
                _this.boundaryErrorTimeout = undefined;
            }
            _this.isShowingBoundaryError = true;
            _this.boundaryErrorTimeout = setTimeout(function () {
                _this.hideBoundaryError();
            }, 4000);
        };
        _this.hideBoundaryError = function () {
            if (!(0, lodash_1.isNil)(_this.boundaryErrorTimeout)) {
                clearTimeout(_this.boundaryErrorTimeout);
                _this.boundaryErrorTimeout = undefined;
            }
            _this.isShowingBoundaryError = false;
        };
        _this.handleBlur = function (event) {
            var _a, _b;
            _this.validateAndClearInternalValue();
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        _this.handleStep = function (direction) {
            var _a = _this.props, value = _a.value, onChange = _a.onChange;
            var newValue = { up: value + 1, down: value - 1 }[direction];
            _this.internalValue = undefined;
            if (!_this.isWithinBoundaries(newValue)) {
                _this.showBoundaryError();
                return;
            }
            onChange(newValue);
        };
        _this.handleOnChange = function (value) {
            _this.updateValue(value);
        };
        _this.handleKeyDown = function (event) {
            var onKeyDown = _this.props.onKeyDown;
            _this.hideBoundaryError();
            switch (event.key) {
                case kaleidoscope_1.KeyType.ArrowUp:
                    event.preventDefault();
                    _this.handleStep("up");
                    break;
                case kaleidoscope_1.KeyType.ArrowDown:
                    event.preventDefault();
                    _this.handleStep("down");
                    break;
                case kaleidoscope_1.KeyType.Enter:
                    event.preventDefault();
                    _this.validateAndClearInternalValue();
                    break;
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        };
        return _this;
    }
    NumberInput.prototype.getBoundaryErrorMessage = function () {
        var _a = this.props, min = _a.min, max = _a.max;
        var minExists = min != undefined;
        var maxExists = max != undefined;
        if (minExists && maxExists) {
            return "Must be between ".concat(min, " and ").concat(max, " ");
        }
        if (minExists) {
            return "Must be at least ".concat(min);
        }
        return "Must be at most ".concat(max);
    };
    NumberInput.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, value = _b.value, _c = _b.autogrow, autogrow = _c === void 0 ? false : _c, _d = _b.showStepper, showStepper = _d === void 0 ? false : _d, min = _b.min, max = _b.max, disabled = _b.disabled, props = __rest(_b, ["value", "autogrow", "showStepper", "min", "max", "disabled"]);
        var Element = autogrow ? AutoGrowTextInput_1.default : kaleidoscope_1.TextInput;
        return (react_1.default.createElement("div", { className: "number-input" },
            react_1.default.createElement("div", { className: "number-input__input" },
                react_1.default.createElement(kaleidoscope_1.Tooltip, { content: this.getBoundaryErrorMessage(), show: this.isShowingBoundaryError, size: kaleidoscope_1.TooltipSize.Large, isError: true },
                    react_1.default.createElement(Element, __assign({}, props, { value: (_a = this.internalValue) !== null && _a !== void 0 ? _a : value.toString(), onChange: this.handleOnChange, onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, inputMode: "numeric", role: "spinbutton", disabled: disabled })))),
            showStepper && (react_1.default.createElement("div", { className: "number-input__stepper" },
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: "number-input__step-button", onClick: function () { return _this.handleStep("up"); }, size: kaleidoscope_1.ButtonSize.XSmall, icon: react_1.default.createElement(icons_1.ChevronUp, { size: icons_1.IconSize.Small }), disabled: (!(0, lodash_1.isUndefined)(max) && value >= max) || disabled, "aria-label": "Increase", "data-qwilr-component": props["data-qwilr-component"] ? "".concat(props["data-qwilr-component"], "-up-step") : null }),
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: "number-input__step-button", onClick: function () { return _this.handleStep("down"); }, size: kaleidoscope_1.ButtonSize.XSmall, icon: react_1.default.createElement(icons_1.ChevronDown, { size: icons_1.IconSize.Small }), disabled: (!(0, lodash_1.isUndefined)(min) && value <= min) || disabled, "aria-label": "Decrease", "data-qwilr-component": props["data-qwilr-component"] ? "".concat(props["data-qwilr-component"], "-down-step") : null })))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], NumberInput.prototype, "internalValue", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "isShowingBoundaryError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "updateValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "validateAndClearInternalValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "showBoundaryError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "hideBoundaryError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "handleStep", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "handleOnChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], NumberInput.prototype, "handleKeyDown", void 0);
    NumberInput = __decorate([
        mobx_react_1.observer
    ], NumberInput);
    return NumberInput;
}(react_1.default.Component));
exports.default = NumberInput;
